import React, { FunctionComponent } from 'react';

import { pageIndex } from 'components/lexemes';
import { CdnImagePath } from 'lib/cdn-image-path';

import { onClickWhatsNewDateCta } from 'containers/events';

import PageSectionCta from 'components/page/sections/page-section-cta';

export const LandingBlockOneContainer: FunctionComponent = () => {
    const props = {
        imageSrc: `${CdnImagePath}/landing/assets/photos/landing-section-1.jpg`,
        imageAlt: '',
        imageObjectPosition: '65% 10%',
        title: pageIndex.lxPageIndexOneBlockTitle,
        text: pageIndex.lxPageIndexOneBlockText,
        actionText: pageIndex.lxPageIndexOneBlockAction,
        actionUrl: '/date',
    };

    return (
        <PageSectionCta
            title={props.title}
            text={props.text}
            action={{
                text: props.actionText,
                href: props.actionUrl,
                onClick: onClickWhatsNewDateCta,
            }}
            image={{
                src: props.imageSrc,
                objectPosition: props.imageObjectPosition,
            }}
            color="orange"
        />
    );
};
